import React from 'react';
import { Button } from './ui/button';
import { LogIn } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const LoginButton = ({ className = '' }) => {
  const handleLogin = () => {
    // Use window.location.origin to dynamically get current domain
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Button
      onClick={handleLogin}
      className={`bg-white/10 border-white/20 text-white hover:bg-white/20 flex items-center gap-2 ${className}`}
      variant="outline"
    >
      <LogIn className="w-5 h-5" />
      <span>Sign In</span>
    </Button>
  );
};

export default LoginButton;
